import { TRIP } from "@/data/content";
import Countdown from "@/components/site/Countdown";
import TripDetails from "@/components/site/TripDetails";
import Pricing from "@/components/site/Pricing";
import WhyTravel from "@/components/site/WhyTravel";
import WhatToBring from "@/components/site/WhatToBring";
import RegistrationForm from "@/components/site/RegistrationForm";
import FAQSection from "@/components/site/FAQSection";
import usePageTitle from "@/hooks/usePageTitle";

export default function OctoberUmrah() {
  usePageTitle("October 2026 Umrah · Maqam Community Initiatives");
  return (
    <div data-testid="page-october-umrah">
      <section className="relative pt-32 md:pt-40 pb-16 md:pb-24 bg-navy text-white overflow-hidden">
        <img
          src="https://images.pexels.com/photos/20735113/pexels-photo-20735113.jpeg"
          alt="Masjid an-Nabawi in Madinah"
          loading="eager"
          className="absolute inset-0 w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8">
          <span className="overline text-gold">Featured Journey</span>
          <h1 className="font-serif text-5xl md:text-7xl mt-3 leading-[1.02] tracking-tight max-w-3xl">
            {TRIP.title}
          </h1>
          <div className="mt-5 flex items-center gap-3">
            <span className="gold-divider" />
            <p className="text-sm tracking-wide text-white/80">{TRIP.dateRange} · {TRIP.duration}</p>
          </div>
          <p className="mt-6 text-white/85 max-w-2xl leading-relaxed">
            Five nights in Madinah and five nights in Makkah — 10 hotel nights across the two holy cities. Five-star accommodations near the Haram and Masjid an-Nabawi,
            guided historical tours, educational seminars, and 24/7 community support.
          </p>
        </div>
      </section>
      <Countdown />
      <TripDetails />
      <Pricing />
      <WhyTravel />
      <WhatToBring />
      <FAQSection />
      <RegistrationForm />
    </div>
  );
}
